export default {
  "content": "<g clip-path=\"url(#clip0_21112_683)\" fill=\"#7B61FF\"><path d=\"M9 4H6.5v16h11v-4h2v4a2 2 0 01-2 2h-11a2 2 0 01-2-2V4a2 2 0 012-2H9v2z\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23 2a1 1 0 01.675 1.737L18.5 8.473V12h2.333v2h-6.666v-2H16.5V8.473l-5.175-4.736A1 1 0 0112 2h11zm-5.5 4.677L20.427 4h-5.854L17.5 6.677z\"/></g><defs><clipPath id=\"clip0_21112_683\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};